import styled from 'styled-components';
import { colors } from 'ui/theme/colors';
import { half } from 'ui/theme/spacing';
import { Overflow16 } from 'ui/icons/aurora/16px/Overflow16';
import { IconButton } from 'ui/button';
import { pxToRem } from 'utils/convert';
import { ActionMenu } from './ActionMenu';
import { ActionMenuOption, MENU_ALIGNMENTS } from './types';
import { BUTTON_SIZES, BUTTON_VARIANTS } from '../button/constants';

export type OverflowButtonProps = {
  /** The options displayed for the action menu */
  options: ActionMenuOption[];
  /** Id tag for the action menu */
  id?: string;
  /** An override to disable the button. Defaults to false */
  isDisabled?: boolean;
  /** positions the action menu. Defaults to right */
  position?: MENU_ALIGNMENTS;
  /** Size of the menu. Menu on page header is LARGE. */
  size?: BUTTON_SIZES;
  /** Variant of the icon button */
  variant?: BUTTON_VARIANTS;
};

const getWidthOfActionMenu = (size: string) => {
  if (size === BUTTON_SIZES.LARGE) {
    return pxToRem(40);
  } else if (size === BUTTON_SIZES.MEDIUM) {
    return pxToRem(36);
  }
};

const getStyleOfButton = (size: string) => size === BUTTON_SIZES.LARGE && `width: ${pxToRem(40)}`;

const disabledStyles = `
  padding: 0 ${half}
`;

export const StyledActionMenu = styled(ActionMenu)`
  width: ${(props) => props.size && getWidthOfActionMenu(props.size)};
`;

const StyledButton = styled(IconButton)`
  ${disabledStyles}
  ${(props) => props.size && getStyleOfButton(props.size)}
`;

export const OverflowMenu = ({
  options,
  id,
  position = MENU_ALIGNMENTS.RIGHT,
  isDisabled = false,
  size,
  variant = BUTTON_VARIANTS.SECONDARY,
  ...rest
}: OverflowButtonProps) => (
  <>
    {isDisabled ? (
      <StyledButton onClick={() => null} isDisabled={isDisabled} size={size} variant={variant}>
        <Overflow16 color={isDisabled ? colors.iconDisabled : colors.iconPrimary} />
      </StyledButton>
    ) : (
      <StyledActionMenu options={options} align={position} id={id} {...rest}>
        <StyledButton onClick={() => null} size={size} variant={variant}>
          <Overflow16 color={colors.iconPrimary} />
        </StyledButton>
      </StyledActionMenu>
    )}
  </>
);
